import { apiService } from './apiService';

const invalidatesCompanyOverview = { invalidatesTags: ['CompanyOverview' as const] };

apiService.enhanceEndpoints({
  endpoints: {
    campaignControllerCampaign: {
      providesTags: (_result, _error, arg) => [{ type: 'Campaign', id: arg.id }],
    },
    handoffRuleCreateControllerExecute: {
      invalidatesTags: [{ type: 'Campaign' }],
    },
    companyOverviewControllerGetCompanyOverview: {
      providesTags: ['CompanyOverview'],
    },
    toolListControllerAgentTollList: {
      providesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolCreateControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolUpdateControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolDeleteControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    campaignCreateControllerCampaignCreate: invalidatesCompanyOverview,
    campaignDeleteControllerDeleteCampaign: invalidatesCompanyOverview,
    campaignRunControllerCampaignRun: invalidatesCompanyOverview,
    campaignStopControllerCampaignStop: invalidatesCompanyOverview,
    userMeControllerUserMe: {
      providesTags: ['UserMe'],
    },
    editUserControllerEditUser: {
      invalidatesTags: ['UserMe'],
    },
  },
});

export { apiService };
